import visualBasic from "refractor/visual-basic";
export default visualBasic;